/**
 * Yvine Design — cookie consent (snippets/art-consent). Records the visitor's
 * choice through Shopify's Customer Privacy API so Shopify analytics / marketing
 * pixels honour it, and remembers it locally so the bar never paints again.
 */
Art.section('consent', function (root) {
  var KEY = 'art_consent';
  var stored = '';
  try { stored = localStorage.getItem(KEY) || ''; } catch (e) {}
  if (stored) { root.hidden = true; return; }

  function record(all) {
    var prefs = { analytics: all, marketing: all, preferences: all, sale_of_data: false };
    function set() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && cp.setTrackingConsent) cp.setTrackingConsent(prefs, function () {});
    }
    if (window.Shopify && window.Shopify.customerPrivacy) set();
    else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) set(); });
    }
    try { localStorage.setItem(KEY, all ? 'all' : 'necessary'); } catch (e) {}
    root.hidden = true;
    document.documentElement.classList.add('art-consented');
  }

  root.querySelector('[data-consent-accept]').addEventListener('click', function () { record(true); });
  root.querySelector('[data-consent-decline]').addEventListener('click', function () { record(false); });
});
